/** CoStar.Api.AnalyticReports.Common.PropertySortOrder */
export var PropertySortOrder;
(function (PropertySortOrder) {
    PropertySortOrder[PropertySortOrder["Default"] = 0] = "Default";
    PropertySortOrder[PropertySortOrder["Tour"] = 1] = "Tour";
    PropertySortOrder[PropertySortOrder["Specified"] = 2] = "Specified";
})(PropertySortOrder || (PropertySortOrder = {}));
/** CoStar.Api.AnalyticReports.Common.GridDataRowType */
export var GridDataRowType;
(function (GridDataRowType) {
    GridDataRowType[GridDataRowType["Detail"] = 0] = "Detail";
    GridDataRowType[GridDataRowType["Header"] = 1] = "Header";
})(GridDataRowType || (GridDataRowType = {}));
/** CoStar.Api.AnalyticReports.Common.PeerResultType */
export var PeerResultType;
(function (PeerResultType) {
    PeerResultType[PeerResultType["CurrentResult"] = 0] = "CurrentResult";
    PeerResultType[PeerResultType["SubmarketWithStarRating"] = 1] = "SubmarketWithStarRating";
    PeerResultType[PeerResultType["Submarket"] = 2] = "Submarket";
    PeerResultType[PeerResultType["Market"] = 3] = "Market";
    PeerResultType[PeerResultType["MarketWithStarRating"] = 4] = "MarketWithStarRating";
    PeerResultType[PeerResultType["SubmarketClusterWithStarRating"] = 5] = "SubmarketClusterWithStarRating";
    PeerResultType[PeerResultType["CurrentSurveyAsQuickPeer"] = 6] = "CurrentSurveyAsQuickPeer";
    PeerResultType[PeerResultType["SubmarketApartmentRentType"] = 7] = "SubmarketApartmentRentType";
    PeerResultType[PeerResultType["CoreBasedStatisticalArea"] = 8] = "CoreBasedStatisticalArea";
    PeerResultType[PeerResultType["CoreBasedStatisticalAreaStarRating"] = 9] = "CoreBasedStatisticalAreaStarRating";
})(PeerResultType || (PeerResultType = {}));
/** CoStar.Api.AnalyticReports.Common.ProductView */
export var ProductView;
(function (ProductView) {
    ProductView[ProductView["Unknown"] = 0] = "Unknown";
    ProductView[ProductView["Results"] = 1] = "Results";
    ProductView[ProductView["Detail"] = 2] = "Detail";
})(ProductView || (ProductView = {}));
/** CoStar.Api.AnalyticReports.Common.DemographicProductRegionType */
export var DemographicProductRegionType;
(function (DemographicProductRegionType) {
    DemographicProductRegionType[DemographicProductRegionType["DemographicOverviewSummary"] = 20] = "DemographicOverviewSummary";
})(DemographicProductRegionType || (DemographicProductRegionType = {}));
/** CoStar.Api.AnalyticReports.Common.DemographicSummaryRowType */
export var DemographicSummaryRowType;
(function (DemographicSummaryRowType) {
    DemographicSummaryRowType[DemographicSummaryRowType["Standard"] = 0] = "Standard";
    DemographicSummaryRowType[DemographicSummaryRowType["Title"] = 1] = "Title";
})(DemographicSummaryRowType || (DemographicSummaryRowType = {}));
/** CoStar.Api.AnalyticReports.Common.SortDirection */
export var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["Unknown"] = 0] = "Unknown";
    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
    SortDirection[SortDirection["Descending"] = 2] = "Descending";
})(SortDirection || (SortDirection = {}));
/** CoStar.Api.AnalyticReports.Common.ReportType */
export var ReportType;
(function (ReportType) {
    ReportType[ReportType["RentAnalytics"] = 0] = "RentAnalytics";
    ReportType[ReportType["VacancyRate"] = 1] = "VacancyRate";
    ReportType[ReportType["IndustrialSubjectProperty"] = 2] = "IndustrialSubjectProperty";
    ReportType[ReportType["MultifamilySubjectProperty"] = 3] = "MultifamilySubjectProperty";
})(ReportType || (ReportType = {}));
/** CoStar.Api.AnalyticReports.Common.TrendVariationType */
export var TrendVariationType;
(function (TrendVariationType) {
    TrendVariationType[TrendVariationType["Equal"] = 0] = "Equal";
    TrendVariationType[TrendVariationType["Positive"] = 1] = "Positive";
    TrendVariationType[TrendVariationType["Negative"] = -1] = "Negative";
})(TrendVariationType || (TrendVariationType = {}));
/** CoStar.Api.AnalyticReports.Common.RangeComparisonType */
export var RangeComparisonType;
(function (RangeComparisonType) {
    RangeComparisonType[RangeComparisonType["None"] = 0] = "None";
    RangeComparisonType[RangeComparisonType["Min"] = 1] = "Min";
    RangeComparisonType[RangeComparisonType["Middle"] = 2] = "Middle";
    RangeComparisonType[RangeComparisonType["Max"] = 3] = "Max";
})(RangeComparisonType || (RangeComparisonType = {}));
/** CoStar.Api.AnalyticReports.Common.GeographyReportType */
export var GeographyReportType;
(function (GeographyReportType) {
    GeographyReportType[GeographyReportType["Submarket"] = 0] = "Submarket";
    GeographyReportType[GeographyReportType["Market"] = 1] = "Market";
    GeographyReportType[GeographyReportType["National"] = 2] = "National";
})(GeographyReportType || (GeographyReportType = {}));
/** CoStar.Api.AnalyticReports.Common.MarketShareRankByType */
export var MarketShareRankByType;
(function (MarketShareRankByType) {
    MarketShareRankByType[MarketShareRankByType["Unknown"] = 0] = "Unknown";
    MarketShareRankByType[MarketShareRankByType["TotalUnits"] = 1] = "TotalUnits";
    MarketShareRankByType[MarketShareRankByType["TotalBuildings"] = 2] = "TotalBuildings";
})(MarketShareRankByType || (MarketShareRankByType = {}));
/** CoStar.Api.AnalyticReports.Common.CompSource */
export var CompSource;
(function (CompSource) {
    CompSource[CompSource["Unknown"] = 0] = "Unknown";
    /** @deprecated Removed in the original enum, use Unknown */
    CompSource[CompSource["Default"] = 1] = "Default";
    CompSource[CompSource["Collaboration"] = 2] = "Collaboration";
    CompSource[CompSource["Radius"] = 3] = "Radius";
    CompSource[CompSource["Custom"] = 4] = "Custom";
    CompSource[CompSource["Linked"] = 5] = "Linked";
})(CompSource || (CompSource = {}));
/** CoStar.Api.AnalyticReports.Common.AreaMeasure */
export var AreaMeasure;
(function (AreaMeasure) {
    AreaMeasure[AreaMeasure["None"] = 0] = "None";
    AreaMeasure[AreaMeasure["SquareFoot"] = 1] = "SquareFoot";
    AreaMeasure[AreaMeasure["SquareMeter"] = 2] = "SquareMeter";
    AreaMeasure[AreaMeasure["Acre"] = 3] = "Acre";
    AreaMeasure[AreaMeasure["Hectare"] = 4] = "Hectare";
})(AreaMeasure || (AreaMeasure = {}));
